import React from "react";
import styles from "./MyRankSkeleton.module.css";

const MyRankSkeleton = () => {
  // Create an array to simulate a list of items
  const skeletonItems = [1, 2, 3, 4, 5];
  // We'll simulate the 3rd item (index 2) being the "Active" one with the big card
  const activeIndex = 2;

  return (
    <div className={styles.container}>
      {/* Header Section */}
      <div className={styles.header}>
        <div
          className={`${styles.titleSkeleton} ${styles.skeletonPulse}`}
        ></div>
        <div
          className={`${styles.subtitleSkeleton} ${styles.skeletonPulse}`}
        ></div>
      </div>

      {/* Timeline List */}
      <div className={styles.timelineList}>
        {skeletonItems.map((item, index) => {
          const isActive = index === activeIndex;
          const isLast = index === skeletonItems.length - 1;

          return (
            <div key={index} className={styles.timelineItem}>
              {/* Left Side: Amount */}
              <div className={styles.targetSide}>
                <div
                  className={`${styles.amountSkeleton} ${styles.skeletonPulse}`}
                ></div>
              </div>

              {/* Center: Dot & Line */}
              <div className={styles.nodeSide}>
                <div
                  className={`${styles.dotSkeleton} ${styles.skeletonPulse}`}
                ></div>
                {!isLast && <div className={styles.lineSkeleton}></div>}
              </div>

              {/* Right Side: Content */}
              <div className={styles.infoSide}>
                {/* Rank Name */}
                <div
                  className={`${styles.rankNameSkeleton} ${styles.skeletonPulse}`}
                ></div>

                {/* Remark Text */}
                <div
                  className={`${styles.remarkSkeleton} ${styles.skeletonPulse}`}
                ></div>

                {/* Expanded Card (Only for the simulated active item) */}
                {isActive && (
                  <div
                    className={`${styles.cardSkeleton} ${styles.skeletonPulse}`}
                  ></div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MyRankSkeleton;
